<template>
  <el-table
    :data="assets"
    stripe
  >
    <el-table-column
      v-if="!!$scopedSlots['peek']"
      type="expand"
    >
      <template v-slot="{ row }">
        <slot
          name="peek"
          :asset="row"
        />
      </template>
    </el-table-column>

    <el-table-column
      label="Serial"
      show-overflow-tooltip
      :width="160"
      :formatter="row => row.serial || '-'"
    />

    <el-table-column
      label="Manufacturer"
      show-overflow-tooltip
      :width="160"
      :formatter="row => $_.get(row, 'manufacturer_model.asset_manufacturer.name', '-') || '-'"
    />

    <el-table-column
      label="Model"
      show-overflow-tooltip
      :width="160"
      :formatter="row => $_.get(row, 'manufacturer_model.name', '-') || '-'"
    />

    <el-table-column
      label="Location"
      show-overflow-tooltip
      :width="260"
    >
      <template v-slot="{ row }">
        {{ getLocation(row) }}
      </template>
    </el-table-column>

    <el-table-column
      label="Status"
      align="center"
      :width="120"
    >
      <template v-slot="{ row }">
        <el-tag
          :type="getStatusTagType(row)"
          size="small"
        >
          {{ (row.status || 'unknown') | titleize }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="right"
      :min-width="120"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :asset="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    assets: {
      type: Array,
      required: true
    }
  },
  methods: {
    getLocation (asset) {
      const latestEvent = [ ...asset.events ]
        .sort((first, second) => {
          return new Date(second.created_at).getTime() - new Date(first.created_at).getTime()
        })
        .shift()

      return (latestEvent ? (latestEvent.profile || latestEvent.account || asset.branch) : asset.branch).label
    },
    getStatusTagType (asset) {
      switch (asset.status) {
        case 'allocated':
          return 'default'
        case 'in stock':
          return 'success'
        case 'warranty':
          return 'warning'
        case 'broken':
          return 'danger'
        default:
          return 'info'
      }
    }
  }
}
</script>
